import { FilterRulesState } from "./types";

const state: FilterRulesState = {
  filterRules: [],
  fullTextSearch: ""
};

export default state;
